import { inject, injectable } from "inversify";
import "reflect-metadata";
import { IReceitaFederalService } from "./ReceitaFederalUseCase";
import { ContabilDITypes } from "@/features/contabil/services/types";
import type { IDashboardGateway } from "@/features/contabil/services/dashboard/gateways/DashboardGateway";

@injectable()
export default class ReceitaFederalService implements IReceitaFederalService {
  @inject(ContabilDITypes.DASHBOARD_GATEWAY)
  client!: IDashboardGateway;

  async buildPainelReceitaFederal() {
    const receitaFederalResponse = await this.client.getReceitaFederal();

    const empecilhoResponse = await this.client.getEmpecilhos();

    return {
      receitaFederalResponse,
      empecilhoResponse
    };
  }
}
